import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../services/firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscriptionTier, setSubscriptionTier] = useState('free');
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('AuthContext: Starting onAuthStateChanged');

    // Check for cached authentication state
    const cachedUser = localStorage.getItem('zenbidup_user');
    if (cachedUser) {
      console.log('AuthContext: Using cached user:', cachedUser);
      setUser(JSON.parse(cachedUser));
      setLoading(false);
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log('AuthContext: onAuthStateChanged triggered, user:', user ? user.uid : 'null');
      setUser(user);
      if (user) {
        console.log('AuthContext: Hardcoding subscription tier to free (Firestore temporarily disabled)');
        setSubscriptionTier('free');
        console.log('AuthContext: User logged in:', user.uid, 'Subscription:', subscriptionTier);
        // Cache the user
        localStorage.setItem('zenbidup_user', JSON.stringify(user));
      } else {
        localStorage.removeItem('zenbidup_user');
      }
      console.log('AuthContext: Setting loading to false');
      setLoading(false);
    }, (err) => {
      console.error('AuthContext: onAuthStateChanged error:', err);
      setError('Failed to authenticate. Please check your network connection and try again.');
      setLoading(false);
    });

    return () => {
      console.log('AuthContext: Unsubscribing from onAuthStateChanged');
      unsubscribe();
    };
  }, []);

  const logout = async () => {
    try {
      console.log('AuthContext: Logging out user');
      await signOut(auth);
      setUser(null);
      setSubscriptionTier('free');
      setError(null);
      localStorage.removeItem('zenbidup_user');
      console.log('AuthContext: Logout successful');
    } catch (err) {
      console.error('AuthContext: Error signing out:', err);
      setError('Failed to sign out. Please try again.');
    }
  };

  const value = {
    user,
    loading,
    subscriptionTier,
    setSubscriptionTier,
    logout,
    error,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  return useContext(AuthContext);
}; 